import React from "react";
import { connect } from "react-redux";
import { useSelector } from 'react-redux';

// components
import Queuing from "../components/Queuing.js";
import ActiveTicket from "../components/queuing/content/ActiveTicket";
import ManageTickets from "../components/queuing/content/ManageTickets";
import TrackingManageTickets from "../components/queuing/content/TrackingManageTickets";
import QuickInfo from "../components/queuing/content/QuickInfo"

import { getMyActiveTicket, getMyWaitingTickets } from "../store/helpers";
import TrackingDetails from "../components/queuing/content/activeTicket/TrackingDetails.js";
import { MANAGEMENT_LOCK } from "../store/constants";
import _ from "lodash";

function Tickets() {
  const { tickets, ticketsFetchedStatus } = useSelector(state => state.tickets); 
  const { authenticatedUser, supportDeskId } = useSelector(state => state.auth);
  const { activeTicketId } = useSelector(state => state.tickets);
  const { customers } = useSelector(state => state.customers);
  const { supportDesks } = useSelector(state => state.services);

  if (!ticketsFetchedStatus) {
    return (
      <Queuing children={
        <>
          <div className="col-one pullLeft allinone">
            <div style={{display:'flex',alignItems:'center',justifyContent:'center',height:'200px'}}>
              <div style={{textAlign:'center'}}>
                <div className="loading-spinner"></div>
                <p style={{marginTop:'15px',color:'#929298',fontSize:'14px'}}>Loading data</p>
              </div>
            </div>
          </div>
          <div className="col-one pullLeft" style={{marginLeft:15}}>
            <QuickInfo />
          </div>
        </>
      } />
    );
  }

  // clone with lodash
  const ticketsClone = _.cloneDeep(tickets);
  const customersClone = _.cloneDeep(customers);
  const supportDesksClone = _.cloneDeep(supportDesks);
  const authenticatedUserClone = _.cloneDeep(authenticatedUser);
  const supportDeskIdClone = _.cloneDeep(supportDeskId);
  const activeTicketIdClone = _.cloneDeep(activeTicketId);

  const activeTicket = getMyActiveTicket(ticketsClone, activeTicketIdClone);
  const nextTickets = getMyWaitingTickets(ticketsClone, authenticatedUserClone, supportDeskIdClone);
  const ticket = activeTicket != null ? activeTicket : nextTickets[0] || null;  

  const customer = ticket != null ? customersClone.find( a => a.mobileNumber === ticket.mobileNumber) : null;
  
  // find auth user supportDesk
  const authUserSupportDesk = supportDesksClone && Array.isArray(supportDesksClone) ? 
    supportDesksClone.find(desk => desk && desk.id === supportDeskIdClone) : null;

  // authUserSupportDesk.backOfficeSupportDesk determines the layout for now
  const lock = authUserSupportDesk?.backOfficeSupportDesk === 1
    ? MANAGEMENT_LOCK.packageTracking
    : MANAGEMENT_LOCK.default;
  
  return (
    <>
      <Queuing
        children={
          <>
            <div className="col-one pullLeft allinone">
              <ActiveTicket ticket={ticket} customer={customer} />
              {
                ticket != null && ticket.tracking != null && ( ticket.tracking.referenceNumber != null || ticket.tracking.trackingNumber != null)
                  ? <TrackingDetails ticket={ticket} />
                  : null
              }
              {
                lock !== null && lock === MANAGEMENT_LOCK.packageTracking
                  ? <TrackingManageTickets ticket={ticket} customer={customer} />
                  : null
              }
              {
                (lock === MANAGEMENT_LOCK.default || lock === null)
                  ? <ManageTickets />
                  : null
              }
            </div>
            <div className="col-one pullLeft" style={{marginLeft:15}}>
              <QuickInfo />
            </div>
          </>
        }
      />
    </>
  );
}

export default connect(null, {})(Tickets);
